// /src/store/userManagment/reducer.ts
import {
  FETCH_USERS_REQUEST,
  FETCH_USERS_SUCCESS,
  FETCH_USERS_FAILURE,
  FETCH_USER_BY_ID_REQUEST,
  FETCH_USER_BY_ID_SUCCESS,
  FETCH_USER_BY_ID_FAILURE,
  FETCH_USER_BY_EMAIL_REQUEST,
  FETCH_USER_BY_EMAIL_SUCCESS,
  FETCH_USER_BY_EMAIL_FAILURE,
  UserState,
  initialState,
  UserActionTypes
} from './types';

const userListReducer = (state = initialState, action: UserActionTypes): UserState => {
  switch (action.type) {
    case FETCH_USERS_REQUEST:
    case FETCH_USER_BY_ID_REQUEST:
    case FETCH_USER_BY_EMAIL_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_USERS_SUCCESS: {
      const usersMap = new Map(state.users);
      const emailToIdMap = new Map(state.emailToIdMap);
      action.payload.users.forEach(user => {
        usersMap.set(user.id, user);
        emailToIdMap.set(user.email, user.id);
      });
      return {
        ...state,
        loading: false,
        users: usersMap,
        emailToIdMap: emailToIdMap,
        lastFetchTimestamp: action.payload.lastFetchTimestamp,
        lastFetchParams: action.payload.lastFetchParams
      };
    }

    case FETCH_USER_BY_ID_SUCCESS:
    case FETCH_USER_BY_EMAIL_SUCCESS: {
      const usersMap = new Map(state.users);
      const emailToIdMap = new Map(state.emailToIdMap);
      usersMap.set(action.payload.id, action.payload);
      emailToIdMap.set(action.payload.email, action.payload.id);
      return {
        ...state,
        loading: false,
        users: usersMap,
        emailToIdMap: emailToIdMap,
        lastFetchTimestamp: Date.now()
      };
    }

    case FETCH_USERS_FAILURE:
    case FETCH_USER_BY_ID_FAILURE:
    case FETCH_USER_BY_EMAIL_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default userListReducer;
